/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FieldRating {
    Ok = '0',
    Error = 1,
    Tolerant = 2,
}
